import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Grid, Button, Alert, CircularProgress } from '@mui/material';
import client from '../api/client';
import { markPaymentDone } from '../api/whatsapp';

const PaymentPage = ({ onComplete }) => {
  const [plans, setPlans] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    client.get('/api/plans').then(res => {
      setPlans(res.data?.plans || res.data || []);
    }).catch(() => setError('Failed to load plans')).finally(() => setLoading(false));
  }, []);

  const handlePay = async (plan) => {
    setPaying(true);
    setError('');
    try {
      await markPaymentDone(plan._id);
      onComplete();
    } catch (err) {
      setError(err.response?.data?.message || 'Payment failed');
      setPaying(false);
    }
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ p: 4, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Choose a Plan</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>Select a plan to activate your WhatsApp API.</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Grid container spacing={3}>
        {(Array.isArray(plans) ? plans : []).map((plan) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={plan._id}>
            <Paper
              sx={{
                p: 3, borderRadius: 3, cursor: 'pointer', border: selected?._id === plan._id ? '2px solid #075e54' : '1px solid #e0e0e0',
                transition: 'all 0.2s', '&:hover': { borderColor: '#075e54' },
              }}
              onClick={() => setSelected(plan)}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{plan.name}</Typography>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#075e54', mb: 2 }}>₹{plan.price}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{plan.description || ''}</Typography>
              <Button
                variant={selected?._id === plan._id ? 'contained' : 'outlined'}
                fullWidth
                disabled={paying}
                onClick={(e) => { e.stopPropagation(); handlePay(plan); }}
                sx={{ textTransform: 'none' }}
              >
                {paying && selected?._id === plan._id ? 'Processing...' : `Pay ₹${plan.price}`}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
      {plans.length === 0 && (
        <Typography variant="body1" sx={{ textAlign: 'center', py: 4 }}>No plans available. Contact admin.</Typography>
      )}
    </Box>
  );
};

export default PaymentPage;
